(function() {
  'use strict';

  function getUTMParams() {
    var params = new URLSearchParams(window.location.search);
    return {
      utm_source: params.get('utm_source') || '',
      utm_campaign: params.get('utm_campaign') || '',
      utm_content: params.get('utm_content') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_term: params.get('utm_term') || '',
    };
  }

  function generateRefCode() {
    var chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
    var code = 'REF-';
    for (var i = 0; i < 6; i++) {
      code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return code;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + d.toUTCString() + ';path=/';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  var utms = getUTMParams();
  if (!utms.utm_source) return;

  var existingRef = getCookie('ads_ref_code');
  var refCode = existingRef || generateRefCode();

  if (!existingRef) {
    setCookie('ads_ref_code', refCode, 30);
    setCookie('ads_utm_data', JSON.stringify(utms), 30);
    try {
      localStorage.setItem('ads_ref_code', refCode);
      localStorage.setItem('ads_utm_data', JSON.stringify(utms));
    } catch(e) {}
  }

  // Track WhatsApp clicks silently — no visible ref code to customer
  function trackWhatsAppClicks() {
    var links = document.querySelectorAll('a[href*="wa.me"], a[href*="whatsapp.com"]');
    links.forEach(function(link) {
      if (link.dataset.adsTracked) return;
      link.dataset.adsTracked = 'true';
      link.addEventListener('click', function() {
        // Log the visitor to the dashboard when they click WhatsApp
        var data = {
          ref_code: refCode,
          utm_source: utms.utm_source,
          utm_campaign: utms.utm_campaign,
          utm_content: utms.utm_content,
          utm_medium: utms.utm_medium,
          utm_term: utms.utm_term,
          landing_page: window.location.pathname,
        };
        // Send to backend (fire and forget)
        try {
          navigator.sendBeacon('/api/tracking/visitor', JSON.stringify(data));
        } catch(e) {
          // Fallback: try fetch
          try {
            fetch('/api/tracking/visitor', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(data),
              keepalive: true,
            });
          } catch(e2) {}
        }
        // Also store ref code in cookie so we can show it on dashboard
        setCookie('ads_wa_clicked', refCode, 30);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackWhatsAppClicks);
  } else {
    trackWhatsAppClicks();
  }

  // Watch for dynamically added WhatsApp links
  var observer = new MutationObserver(trackWhatsAppClicks);
  observer.observe(document.body, { childList: true, subtree: true });
})();
